'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Dialog } from '@module/mdrt-org/shared/components/dialog/dialog';
import { MarkAllAsReadButton } from '@module/mdrt-org/shared/components/header/components/notifications/mark-all-as-read-button/mark-all-as-read-button';
import { NotificationsList } from '@module/mdrt-org/shared/components/header/components/notifications/notifications-list/notifications-list';
import { useGlobalCmsContentContext } from '@module/mdrt-org/shared/components/providers/global-cms-context';
import { useNotifications } from '@module/mdrt-org/shared/components/providers/notifications-context';
import { useBreakpoint } from '@module/mdrt-org/shared/utils/hooks/use-breakpoint';
import { ModalTrigger } from '@shared/ui-components/modal/modal';
import { NotificationsButton } from '../notifications-button/notifications-button';
import styles from './notifications-modal-trigger.module.scss';
export const NotificationsModalTrigger = () => {
  const $ = _c(6);
  const {
    cmsContent
  } = useNotifications();
  const {
    cmsContent: t0
  } = useGlobalCmsContentContext();
  const {
    closeButtonLabel
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const {
    isLargeDesktop
  } = useBreakpoint();
  if (isLargeDesktop && isOpen) {
    setIsOpen(false);
  }
  let t1;
  if ($[0] !== closeButtonLabel || $[1] !== cmsContent.notificationsTitle) {
    t1 = handleClose => <Dialog className={styles["notifications-dialog"]} closeButtonLabel={closeButtonLabel} contentClassName={styles["notifications-dialog__content"]} hasCloseButton={true} headerAction={<MarkAllAsReadButton isSmall={false} />} headerClassName={styles["notifications-dialog__header"]} onModalClose={handleClose} title={cmsContent.notificationsTitle}><NotificationsList /></Dialog>;
    $[0] = closeButtonLabel;
    $[1] = cmsContent.notificationsTitle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isOpen || $[4] !== t1) {
    t2 = <ModalTrigger containerClassName={styles["notifications-modal-container"]} isOpen={isOpen} onOpenChange={setIsOpen} overlayClassName={styles["notifications-modal-overlay"]} renderTrigger={_temp}>{t1}</ModalTrigger>;
    $[3] = isOpen;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
function _temp(t0) {
  const {
    handleModalOpen
  } = t0;
  return <NotificationsButton onClick={handleModalOpen} />;
}